import Cookie from '@component/common/src/util/Cookie';
import AccountNotificationsModel from '../../../common/components/AccountNotifications/AccountNotificationsModel';
import ResponsiveUtil from '../../utils/ResponsiveUtil';
import AccountNotificationsView from './AccountNotificationsView';
import '../../../scss/_dontExtract_/mcom/components/AccountNotifications/AccountNotifications.scss';
import '../../../scss/_dontExtract_/mcom/components/NotificationsIcon/NotificationsIcon.scss';
import signedInUser from '../../../common/util/signed-in-user';

export default class Component {
  constructor(options) {
    if (signedInUser()) {
      const opts = options || {};
      const deviceType = ResponsiveUtil.getDevice();
      // the pageType value is tracked from the page, as it is stored on loading the page.
      this.model = new AccountNotificationsModel({
        id: Cookie.get('macys_online_uid'),
        onMyAccountPage: opts.onMyAccountPage || window.location.pathname.startsWith('/myaccount/home'),
        pageType: localStorage.getItem('pageType'),
        deviceType,
      });
      if (!opts.el) {
        opts.el = '#account-notification-indicator';
      }
      this.view = new AccountNotificationsView({
        model: this.model,
        el: opts.el,
      });
      return this;
    }
  }
}
